export const useManageSurveyDimensionColumns = () => {
	const nameColumn = {
		name: 'Name',
		displayText: 'Name',
		checked: true,
		displayOrder: 0,
		disabled: false,
	};

	const questionsColumn = {
		name: 'Questions',
		displayText: 'Questions',
		checked: true,
		displayOrder: 1,
		disabled: false,
	};

	const sourceColumn = {
		name: 'Source',
		displayText: 'Source',
		checked: false,
		displayOrder: 2,
		disabled: false,
	};

	const typeColumn = {
		name: 'Type',
		displayText: 'Type',
		checked: false,
		displayOrder: 3,
		disabled: false,
	};

	const responseOptionColumn = {
		name: 'ResponseOption',
		displayText: 'Response Option',
		checked: true,
		displayOrder: 4,
		disabled: false,
	};

	const scoredColumn = {
		name: 'Scored',
		displayText: 'Scored',
		checked: true,
		displayOrder: 5,
		disabled: false,
	};

	const actionsColumn = {
		name: 'Actions',
		displayText: 'Actions',
		checked: true,
		displayOrder: 6,
		disabled: false,
	};

	return {
		nameColumn,
		questionsColumn,
		sourceColumn,
		typeColumn,
		responseOptionColumn,
		scoredColumn,
		actionsColumn,
		manageSurveyDimensionsColumns: [
			nameColumn,
			questionsColumn,
			sourceColumn,
			typeColumn,
			responseOptionColumn,
			scoredColumn,
			actionsColumn,
		],
	};
};
